module.exports = __webpack_public_path__ + "static/media/emojione_flag-for-brazil.cd6460c0.svg";